let config = {};
let authToken;
let queryStrings = window.location.search.substr(1).split("&");

queryStrings.forEach((queryString) => {
  if (queryString.indexOf("token=") === 0) {
    authToken = queryString.substr(6);
  }
});

config.authToken = authToken;

config.EDITOR_URL = 'http://beta.activds.com';
config.BACKEND_URL = 'http://beta.activds.com:3000';
config.IMAGE_UPLOAD = config.BACKEND_URL + '/upload/website/image';
config.UPDATE_PAGE = config.BACKEND_URL + '/updatePage';

module.exports = config;



// WEBPACK FOOTER //
// ./config/production.js